import { deleteData, getData, postData, putData } from "./APIServiceInterface";

export const getToolsService = async () => {
  const response = await getData("/tool/get");
  return response;
};

export const createNewToolService = async (payload) => {
  const response = await putData("/tool/create", payload);
  return response;
};

export const updateToolService = async (id, payload) => {
  return await postData(`/tool/update?toolId=${id}`, payload);
};

export const deleteToolService = async (payload) => {
  return await deleteData(`/tool/delete?toolId=${payload}`);
};

